import { Component, Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { StateService } from '../../../core/providers/state/state.service';
import { Title } from '@angular/platform-browser';
import { isPlatformBrowser } from '@angular/common';

@Component({
    selector: 'vsf-under-construction-page',
    templateUrl: './under-construction-page.component.html',
})

export class UnderConstructionPageComponent implements OnInit, OnDestroy {
    private sub: Subscription;
    constructor(private router: Router,
        private stateService: StateService,
        private titleService: Title,
        @Inject(PLATFORM_ID) private platformId: object,
    ) {}
    async ngOnInit() {
        this.sub = this.stateService.select(state => state.storeStatus)
            .subscribe((status) => {
                if (status === 'published') {
                    this.router.navigate(['/']);
                } else {
                    if(isPlatformBrowser(this.platformId)) {
                        this.titleService.setTitle('Under Construction');
                    }
                }
            });
    }
    async ngOnDestroy() {
        if(this.sub) {
            this.sub.unsubscribe();
        }
    }
}
